import {
  AdminAppAction,
  EventActionType,
  LoadEventErrorAction,
  LoadEventRequestAction,
  LoadEventSuccessAction,
  loadEventError,
  loadEventSuccess,
  loadImage,
} from '../../actions';
import { Epic, ofType } from 'redux-observable';
import {
  GET_EVENT_QUERY,
  GetEventData,
  GetEventVariables,
} from '../../queries';
import { mergeAll, switchMap } from 'rxjs/operators';
import { AdminAppState } from '../../state';
import { EpicDependencies } from '../epic-dependencies';
import { of } from 'rxjs';

export const loadEventEpic: Epic<
  AdminAppAction,
  LoadEventSuccessAction | LoadEventErrorAction,
  AdminAppState,
  EpicDependencies
> = (action$, state, { client }) =>
  action$.pipe(
    ofType<AdminAppAction, LoadEventRequestAction>(
      EventActionType.LoadEventRequest,
    ),
    switchMap(async (action: LoadEventRequestAction) => {
      const { data, errors } = await client.query<
        GetEventData,
        GetEventVariables
      >({
        errorPolicy: 'all',
        fetchPolicy: 'network-only',
        query: GET_EVENT_QUERY,
        variables: {
          id: action.eventKey,
        },
      });

      if (errors) {
        return of(loadEventError(action.eventKey, errors));
      } else if (data) {
        const tags = data.event.tags.map(tag => tag.name).join(' ');

        const imageActions = data.event.images.map(posterImage =>
          loadImage(posterImage.image.id, {
            id: posterImage.image.id,
            url: posterImage.image.url,
          }),
        );

        const posterImages = data.event.images.map(posterImage => ({
          imageKey: posterImage.image.id,
          type: posterImage.type,
        }));

        const occurrences: any = data.event.eventOccurrences.edges.map(
          edge => ({
            startsAt: edge.node.startsAt,
            duration: edge.node.duration,
          }),
        );

        return of(
          loadEventSuccess(action.eventKey, {
            id: data.event.id,
            description: data.event.description,
            name: data.event.name,
            occurrences,
            posterImages,
            pageId: data.event.page ? data.event.page.id : null,
            pageTitle: data.event.page ? data.event.page.title : null,
            placeId: data.event.place ? data.event.place.id : null,
            placeName: data.event.place ? data.event.place.name : null,
            tags,
          }),
          ...(imageActions as any),
        );
      } else {
        throw new Error('No data.');
      }
    }),
    mergeAll(),
  );
